import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import BestIcon from 'assets/icons/icon-bestCase.png';
import MostIcon from 'assets/icons/icon-mostLikely.png';
import WorstIcon from 'assets/icons/icon-worstCase.png';
import './InvestmentPortfolioGraph.scss';

const InvestmentPortfolioGraph = ({ bestCase, mostLikely, worstCase }) => (
  <ul className="investment-portfolio-graph">
    <li>
      <img src={BestIcon} alt="Best Case Increase" />
      <FormattedMessage id="risk.bestCase" />
      <strong>{bestCase}</strong>
    </li>
    <li>
      <img src={MostIcon} alt="Most Likely Result" />
      <FormattedMessage id="risk.mostLikely" />
      <strong>{mostLikely}</strong>
    </li>
    <li>
      <img src={WorstIcon} alt="Worst Case Losses" />
      <FormattedMessage id="risk.worstCase" />
      <strong>{worstCase}</strong>
    </li>
  </ul>
);

InvestmentPortfolioGraph.propTypes = {
  /** Best case increase */
  bestCase: PropTypes.string,
  /** Most likely result */
  mostLikely: PropTypes.string,
  /** Worst case losses */
  worstCase: PropTypes.string,
};

InvestmentPortfolioGraph.defaultProps = {
  bestCase: null,
  mostLikely: null,
  worstCase: null,
};

export default InvestmentPortfolioGraph;
